module.exports = __webpack_public_path__ + "static/media/logo-tanitech.a88f73c6.png";